import React from 'react';
import { Modal, Button } from 'antd';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import FailedIcon from 'pages/dashboard/PPAKlarityReviewsDashboradPage/images/failed.svg';
import SuccessIcon from 'pages/dashboard/PPAKlarityReviewsDashboradPage/images/success.svg';

export enum EAiResultType {
    PUBLIC_APPROVED = 'PUBLIC_APPROVED',
    PUBLIC_FAILED = 'PUBLIC_FAILED',
    PRIVATE_APPROVED = 'PRIVATE_APPROVED',
    PRIVATE_FAILED = 'PRIVATE_FAILED',
}

interface IProps {
    open: boolean;
    type: EAiResultType;
    selectedReason?: string;
    onClose: () => void;
}

const AiResultModal = ({ open, type, selectedReason, onClose }: IProps) => {
    const getContent = () => {
        switch (type) {
            case EAiResultType.PUBLIC_APPROVED:
                return {
                    title: 'Dispute approved',
                    description: 'This review was found to violate Klarity\'s review guidelines and has been removed from HelloKlarity.com. The score won\'t count toward your weighted average rating.',
                };
            case EAiResultType.PUBLIC_FAILED:
                return {
                    title: 'Dispute denied',
                    description: `Upon our assessment, this feedback does not contain ${selectedReason || 'the selected reason'} and therefore does not violate Klarity's review guidelines. It will remain visible on HelloKlarity.com, and its score will continue to count toward your weighted average rating. You may still post a HIPAA-safe public reply within 30 days of the original review date.`,
                };
            case EAiResultType.PRIVATE_APPROVED:
                return {
                    title: 'Dispute approved',
                    description: 'This review was found to violate Klarity\'s review guidelines. The score won\'t count toward your weighted average rating.',
                };
            case EAiResultType.PRIVATE_FAILED:
                return {
                    title: 'Dispute denied',
                    description: `Upon our assessment, this review does not contain ${selectedReason || 'the selected reason'} and therefore does not violate Klarity's review guidelines. Its score will continue to count toward your weighted average rating.`,
                };
            default:
                return {
                    title: '',
                    description: '',
                };
        }
    };

    const content = getContent();

    return (
        <Modal
            width={780}
            open={open}
            title="Submit review dispute"
            className={commonS.modalFixHeightWrap}
            footer={[
                <Button
                    key="close"
                    type="primary"
                    onClick={onClose}
                >
                    Close
                </Button>,
            ]}
            onCancel={onClose}
        >
            <div className={s.wrap}>
                <div className={s.iconContainer}>
                    <div className={s.icon}>
                        {type === EAiResultType.PUBLIC_FAILED || type === EAiResultType.PRIVATE_FAILED ? (
                            <img src={FailedIcon} alt="failed" />
                        ) : (
                            <img src={SuccessIcon} alt="success" />
                        )}
                    </div>
                </div>
                <div className={s.content}>
                    <div className={s.title}>{content.title}</div>
                    <p className={s.description}>{content.description}</p>
                </div>
            </div>
        </Modal>
    );
};

export default AiResultModal;
